import Disclosure from "../utils/Disclosure.js";
import { debounce } from "../utils/Performance";

class PageNavigation {
    constructor(element) {
        this.el = element;

        this.navPanel = this.el.querySelectorAll("#pageNavigation");

        this.init();

        // window.addEventListener(
        //     "resize",
        //     debounce(() => {
        //         this.init();
        //     }, 250),
        // );
    }

    init() {
        const isMobile = window.matchMedia("(max-width: 819px)").matches; // Check the media query

        if (isMobile) {
            if (this.navPanel.length > 0) {
                this.navPanel.forEach((element) => {
                    if (element instanceof Element) {
                        const disclosure = new Disclosure(element, {
                            animate: true,
                            collapseOnAncestorCollapse: false,
                            collapseOnOtherElementsExpand: null,
                        });

                        disclosure.collapse();

                    }
                });
            }
        } else {
            if (this.navPanel.length > 0) {
                this.navPanel.forEach((element) => {
                    element.removeAttribute("aria-hidden");
                    element.removeAttribute("hidden");
                });
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector(".page-navigation");

    if (element) {
        new PageNavigation(element);
    }
});
